export function normalizeStyleType(entityType, type) {
    if (entityType === "cms.sections") return "section";
    if (entityType === "cms.layouts") return "page-layout";
    if (type === "structured") return "layout";
    if (type === "contact-form") return "form";
    return type;
}
